import { memo } from 'react'
import NavBarButton from '../NavBarButton/NavBarButton'
import LineSuitcaseIcon from 'LuxKit/Icons/line/LineSuitcaseIcon'
import usePurchaseSynonymLabels from 'hooks/usePurchaseSynonymLabels'

interface Props {
  className?: string
}

function NavBarMyEscapesButton(props: Props) {
  const { myPurchases: buttonText } = usePurchaseSynonymLabels()

  return <NavBarButton
    className={props.className}
    icon={<LineSuitcaseIcon />}
    to="/account/my-escapes"
    contentBreakpointMin="desktop"
    aria-label={buttonText}
  >
    {buttonText}
  </NavBarButton>
}

export default memo(NavBarMyEscapesButton)
